This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div
    class="draggable drag-4"
    :class="checker ? 'selected' : ''"
    @click="clicked"
  >
    <div class="arithop" ref="arithop">
      <!-- Block as shown in the instructions container -->
      <div class="preview">
        {{ getType(type) }}
      </div>

      <!-- Block as shown in the PSD/IDE -->
      <div class="hidden codeBlock parent numOnly" ref="arithop">
        <div class="blockEntry upperBorder value lhs"></div>
        <p>{{ getType(type) }}</p>
        <div class="blockEntry upperBorder value rhs"></div>

        <div class="var-input">
          <input type="text" class="hidden" autocomplete="off" />
          <select class="hidden"></select>
        </div>
        <!-- <div class="tooltip">
          <button class="button neutral hidden">
            <img src="@/assets/images/icons/Switch.svg" alt="Breakpoint icon" />
          </button>
          <div class="tooltipText top-6">
            <p>{{ $t("game.tooltips.psdSwitch") }}</p>
            <i></i>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { ArithOpType } from "@/utils/Types";
import { addExtra, checkUsedBlock } from "@/utils/Functions";

@Options({
  name: "arith-op-block",
  props: {
    type: ArithOpType,
  },
  methods: {
    //Get the type of the operator to display
    getType(type: ArithOpType) {
      switch (type) {
        case ArithOpType.add:
          return "+";
        case ArithOpType.subtract:
          return "-";
        case ArithOpType.multiply:
          return "*";
        case ArithOpType.divide:
          return "/";
        case ArithOpType.mod:
          return "%";
        case ArithOpType.power:
          return "^";
        default:
          return "";
      }
    },
    getTranslation(s: string) {
      return this.json[this.lang][s];
    },
    clicked() {
      addExtra(this.type);
    },
  },
  computed: {
    checker() {
      return checkUsedBlock(this.type);
    },
  },
  mounted() {
    this.$refs.arithop.classList.add(this.type);
  },
})
export default class ArithOp extends Vue {}
</script>
